import React from "react";
import { icons } from "../../components";

function IconComponent(props) {
	const Icon = icons[props.name];

	return Icon ? (
		<Icon
			onClick={props?.onClick}
			className={`richtext-w-4 richtext-h-4 ${props?.className || ""}`}
		/>
	) : null;
}

export { IconComponent };
